// extracted by mini-css-extract-plugin
export var numpadContainer = "_jx-1";
export var phoneButton = "_jx-0";